module.exports = __webpack_public_path__ + "static/media/Header-Background-Image.3951d8dd.png";